// src/components/LoginPage.js
import React, { useState, useEffect } from "react";
import { requestHeaders, requests } from "./../NetworkUtils/Requests";
import axios from "axios";
import "../page css components/LoginPage.css";
import { useHistory, useLocation } from "react-router-dom";
import Header from "./Header";
import { AppDispatch } from "../state";
import { useDispatch } from "react-redux";
import { User_details_Action } from "../state/action-creators";
import { toast } from "react-toastify";

const LoginPage = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    showPassword: false,
  });

  const [response, setresponse] = useState("");
  const history = useHistory();
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();

  const submitForm = async () => {
    const Data = {
      userId: formData.username,
      password: formData.password,
    };

    await axios
      .post(`${requestHeaders.rooturl}${requests.Login}`, Data, {
        withCredentials: true,
      })
      .then((res) => {
        // history.push("/listings");
        // if (history.length > 1)
        //   setTimeout(() => {
        //     history.goBack();
        //   }, 100);
        // else history.push("/listings/top");

        const returnUrl = new URLSearchParams(location.search).get("returnUrl");

        if (returnUrl) {
          // Redirect the user to the return URL after successful login
          history.push(returnUrl);
        } else {
          // Redirect to a default page if no return URL is available
          history.push("/listings/top");
        }

        // history.replace("listings/top");
        dispatch(User_details_Action(res.data));
      })
      .catch((error) => {
        toast.error("Invalid user credentials!", {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
        });
        console.log(error.response);
        setresponse(error.response.data.message);
      });
  };

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = () => {
    setFormData((prevState) => ({
      ...prevState,
      showPassword: !prevState.showPassword,
    }));
  };

  return (
    <div>
      <Header />

      <div className="login-page">
        <form>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type={formData.showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="checkbox-container">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={formData.showPassword}
                onChange={handleCheckboxChange}
              />
              Show Password
            </label>
          </div>
          <button type="button" onClick={submitForm}>
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
